import { render, staticRenderFns } from "./VeloAbo.vue?vue&type=template&id=3652f1bb&"
import script from "./VeloAbo.vue?vue&type=script&lang=js&"
export * from "./VeloAbo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports